// src/project/data/fetches/withdrawals.js
// Historique des transactions du livreur via l'API wallet V3
import { buildUrlWithAuth, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'

export default {
  url() {
    const userId = getUserId()
    if (!userId) return 'https://local-mock'
    return buildUrlWithAuth(RIDER_ENDPOINTS.WALLET_TRANSACTIONS(userId))
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: 200,
        message: 'Ok',
        data: [],
      }
    }
    const transactions = raw?.data || []
    
    const STATUS_LABELS = {
      initiated: 'En cours',
      completed: 'Complété',
      failed: 'Échoué',
      pending: 'En attente',
      unstarted: 'Non démarré',
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: transactions
        .filter(t => !!t.src?.wallet)
        .map(t => {
          const feeObj = t.metadata?.fees || {}

          return {
            id: t.id,
            type: 'debit', // Si la src est un wallet, c'est un débit
            date: t.createdAt,
            amount: t.src?.amount || t.dst?.amount || 0,
            currency: t.src?.currency || 'XOF',
            phoneNumber: t.dst?.phoneNumber || '',
            operator: (t.dst?.processor || '').toUpperCase(),
            status: t.status || 'unknown',
            statusDisplay: STATUS_LABELS[t.status] || t.status || 'Inconnu',
            createdAt: t.createdAt,
            narration: t.metadata?.narration || 'Retrait',
            // Informations sur les frais
            fees: {
              srcAmount: feeObj.srcAmount || 0,
              dstAmount: feeObj.dstAmount || 0,
              totalFeeCalculated: feeObj.totalFeeCalculated || 0,
              feePercent: feeObj.feePercent || 0,
              feeFix: feeObj.feeFix || 0,
              feePercentCalculated: feeObj.feePercentCalculated || 0,
              applyFeeOnSrc: feeObj.applyFeeOnSrc ?? false,
            },
            // Référence pour traçabilité
            ref: t.id,
          }
        }),
    }
  },
}